import React, { useState, useEffect, FC, JSX } from "react";
import { useAdmin } from "../../context/AdminContext";
import CompanyManagementTable from "../../components/company/CompanyManagementTable";

const PendingCompanies: FC = (): JSX.Element => {
  const {
    pendingCompanies,
    loadingState,
    errorState,
    fetchPendingCompanies,
    updateCompanyVerificationStatus,
  } = useAdmin();

  // useEffect(() => {
  //   fetchPendingCompanies();
  // }, []);

  return (
    <CompanyManagementTable
      companies={pendingCompanies}
      loading={loadingState.pendingCompanies}
      error={errorState.pendingCompanies}
      onRefresh={fetchPendingCompanies}
      onUpdateVerificationStatus={updateCompanyVerificationStatus}
      isAdminView={true} // Admin view
      pageTitle="Pending Company Approvals"
      pageDescription="Review and approve company registrations"
      showFilter={false}
      showReviewGuidelines={true}
      showVerificationHistory={true} // Admin can see history for pending companies
    />
  );
};

export default PendingCompanies;
